import { getLegacyBindingContext } from "@visactor/vrender-core/legacy/bootstrap";

import { registerGlyphGraphic } from "@visactor/vrender-core/register/graphic";

import { glyphModule } from "@visactor/vrender-core/graphic/modules";

import { browser } from "./env";

import { bindGlyphCanvasPickerContribution } from "../picker/contributions/canvas-picker/glyph-module";

import { bindGlyphMathPickerContribution } from "../picker/contributions/math-picker/glyph-module";

function _registerGlyph() {
    if (_registerGlyph.__loaded) return;
    _registerGlyph.__loaded = !0;
    const legacyContext = getLegacyBindingContext();
    registerGlyphGraphic(), glyphModule({
        bind: legacyContext.bind
    }), browser ? bindGlyphCanvasPickerContribution(legacyContext) : bindGlyphMathPickerContribution(legacyContext);
}

_registerGlyph.__loaded = !1;

export const registerGlyph = _registerGlyph;
//# sourceMappingURL=register-glyph.js.map